import React from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { Case, Switch } from '@chipp972/react-case-when';
import 'instantsearch.css/themes/satellite.css';
import { useAppSelector } from '@/store/store';
import { UserRole } from '@/utils/userType';

import { router } from '../router';
import { useAppHook } from './app.hooks';
import { Loader } from './Loader/Loader';
import { useAuthListeners } from './Auth/useAuthListeners';

export const App = () => {
  const { appError, isLoadingLang } = useAppHook();
  const { isOidcReady } = useAuthListeners();
  const unauthorizedUser = useAppSelector(state => state.user.role === UserRole.UNAUTHORIZED);

  return (
    <Switch>
      <Case when={appError}>Missing config</Case>
      <Case when={isLoadingLang || !isOidcReady}>
        <Loader size="large" />
      </Case>
      <Case>
        <RouterProvider router={router} context={{ unauthorizedUser }} />
      </Case>
    </Switch>
  );
};
